import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { UserService } from '../services/user/user.service';
import { SharedService } from '../services/shared/shared.service';

@Component({
  selector: 'app-pwd-reset',
  templateUrl: './pwd-reset.component.html',
  styleUrls: ['./pwd-reset.component.css']
})
export class PwdResetComponent implements OnInit {
  confirmPassword:String=null;
  newPassword:String=null;
  currentPassword:String=null;
  showPasswordPolicy:Boolean=false;
  isStrongPassword:Boolean=false;
  passwordResetSuccess:Boolean = false;
  constructor(public router:Router,public foruscareService: ForuscareService,
    public activatedroute:ActivatedRoute,public userService:UserService,public sharedService:SharedService) { }

  ngOnInit() {
  }

  pwdResetFormSubmit() {
    if((this.currentPassword==null || this.currentPassword.trim().length==0) ||
      (this.newPassword==null || this.newPassword.trim().length==0) ||
      (this.confirmPassword==null || this.confirmPassword.trim().length==0)){
        this.foruscareService.showNotification("Enter all mandatory fields.", "danger");
        return;
    }
    else if(this.newPassword!=null && !this.foruscareService.verifyPasswordStrength(this.newPassword.trim())){
      this.foruscareService.showNotification("Please fill the strong password as per the password policy.", "danger");
      return;
    }
    else{
      this.activatedroute.paramMap.subscribe(params=>{
        var obj={
          email:params.get('userid'),
          password:this.newPassword,
          oldPassword:this.currentPassword
        }
        this.userService.resetUserPassword(obj)
        .subscribe(response=>{
          if(response.errorCode==200){
            this.passwordResetSuccess = true;
          }
          else if(response.errorCode==401){
            this.foruscareService.showNotification('This password is already used in past. Please enter new password','danger');
        }
          else{
            this.foruscareService.showNotification('Something went wrong! please try again','danger');
          }
        });
      });
    }
  }
  backToLoginPage(){
    this.sharedService.removeAccessToken();
    this.router.navigate(['/login']);
  }
  /*start : check strong password */
  checkStrongPassword(password){
    return this.foruscareService.verifyPasswordStrength(password);
  }
  /*end : check strong password */

}
